import { useEffect } from 'react';
import styles from './subscribe.module.css';
import { useState } from 'react';
import axios from 'axios';
import { ArrowLeft, Check } from 'react-feather';
import { authData, withAdminAuth } from '../../components/GetAuth';
import { SubscribeLoader } from '../../components/ContentLoader';
import { PayPalButtons } from '@paypal/react-paypal-js';
import { useNavigate } from "react-router-dom";
import { StorageSetItem, STORAGE_KEYS } from '../../components/StorageComp';
import PageHeader from '../../components/PageHeader';
import { useWebsite } from '../../../context/WebsiteContext';
import { useSiteBranding } from '../../../hooks/useSiteBranding';

const PLAN_FEATURES = {
  Standard: ['Bookings', 'Customers', 'Items', 'Customer Portal'],
  Premium: ['Everything in Standard', 'Driver Management', 'Shipping & Delivery', 'Apps Included'],
  Full: ['Everything in Premium', 'Referral System', 'Membership Benefits', '24/7 Support'],
};

function Subscribe() {
  const auth = authData();
  const navigate = useNavigate();
  const API_TOKEN = auth?.api_token;
  const [planList, setPlanList] = useState([]);
  const [contentLoading, setContentLoading] = useState(true);
  const [selectedPlan, setSelectedPlan] = useState(null);

  const { websiteData } = useWebsite();
  useSiteBranding("Subscribe you plan", websiteData);

  useEffect(() => {
    const fetchCompany = () => {
      setContentLoading(true);
      axios.get(process.env.REACT_APP_API_URL + "v1/plan-list", {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        }
      }).then((response) => {
        setContentLoading(false);
        setPlanList(response.data.data);
      }).catch((error) => {
        setContentLoading(false);
      });
    };

    fetchCompany();
  }, [API_TOKEN]);

  const createOrder = (data, actions) => {
    return actions.order.create({
      purchase_units: [
        {
          description: "Purchage Subscribe Plan",
          amount: {
            currency_code: "GBP",
            value: selectedPlan?.monthly_amount,
          },
        },
      ],
      application_context: {
        shipping_preference: "NO_SHIPPING",
      },
    }).then((orderID) => {
      return orderID;
    });
  };

  const onApprove = (data, actions) => {
    return actions.order.capture().then(function (details) {
      let postData = {};
      postData = { ...postData, subscription_id: selectedPlan?.id, total_booking: selectedPlan?.no_of_booking, payment_amount: details?.purchase_units[0]?.payments?.captures[0]?.amount?.value, transaction_id: details?.purchase_units[0]?.payments?.captures[0]?.id, payer_id: details?.payer?.payer_id, payer_name: details?.payer?.name?.given_name + ' ' + details?.payer?.name?.surname, payer_email: details?.payer?.email_address };

      axios.post(process.env.REACT_APP_API_URL + "v1/add-subscription", postData, {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        }
      }).then((response) => {
        setContentLoading(false);
        if (auth) {
          let authTemp = auth;
          authTemp = { ...authTemp, subscription: response.data.data };
          StorageSetItem(STORAGE_KEYS.AUTH, authTemp, 24 * 60 * 60 * 1000);
        }
        navigate("/subscribe-success");
      }).catch((error) => {
        setContentLoading(false);
      });
    });
  };

  return (<div className={`${styles.MainDiv}`}>
    <PageHeader title="Subscribe" />

    {contentLoading && <div className={`${styles.MainCard}`}><div className={`${styles.Container}`}><SubscribeLoader cards={3} /></div></div>}

    {!contentLoading && <div className={`${styles.MainCard}`}>
      <div className={`${styles.Container}`}>

        {!selectedPlan && <>
          <h2 className={`${styles.SubscribeTitle}`}>Pick a plan then pay for usage</h2>

          <div className={`${styles.SubscribeRow}`}>

            {planList?.map(item => {
              const isPopular = item?.name === 'Premium';
              return <div key={item?.id} className={`${styles.SubscribeCard} ${isPopular ? styles.SubscribeCardPopular : ''}`}>
                <div className={`${styles.SubscribeCardUnder}`}>
                  {isPopular && <span className={`${styles.PopularBadge}`}>Most Popular</span>}
                  <div className={`${styles.SubscribeCardTopSec}`}>
                    <p className={`${styles.SubscribePlanTitle}`}>{item?.name}</p>
                    <p className={`${styles.SubscribePlanDes}`}>{item?.description}</p>
                    <p className={`${styles.SubscribePlanAmount}`}>&pound;{item?.monthly_amount}<span>/Month</span></p>
                  </div>
                  <div className={`${styles.SubscribeList}`}>
                    {(PLAN_FEATURES[item?.name] || []).map((feature) => (
                      <p key={feature}><Check /> {feature}</p>
                    ))}
                  </div>
                  <button onClick={(e) => setSelectedPlan(item)} className={`${styles.SubscribeBU}`}>Subscribe</button>
                </div>
              </div>
            })}
          </div>
        </>}

        {selectedPlan && <div className={`${styles.SubscribePaySec}`}>
          <button onClick={(e) => setSelectedPlan(null)} className={`${styles.BackArrow}`}><ArrowLeft />Back</button>
          <p className={`${styles.PlanPayTitle}`}>Plan: {selectedPlan?.name}</p>
          <p className={`${styles.PlanPayAmount}`}>Payable Amount: &pound;{selectedPlan?.monthly_amount}</p>

          <PayPalButtons style={{ layout: "vertical" }} createOrder={createOrder} onApprove={onApprove} />
        </div>}

      </div>
    </div>}


  </div>);
}

export default withAdminAuth(Subscribe);